"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _app, _connector, _contractCache;
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
const ContractCache_1 = __importDefault(require("./helpers/ContractCache"));
class Hatch {
    constructor(connector, app) {
        _app.set(this, void 0);
        _connector.set(this, void 0);
        _contractCache.set(this, void 0);
        __classPrivateFieldSet(this, _connector, connector);
        __classPrivateFieldSet(this, _app, app);
        __classPrivateFieldSet(this, _contractCache, new ContractCache_1.default(app.organization));
    }
    /**
     * Disconnect the connector from the subgraph.
     */
    async disconnect() {
        __classPrivateFieldGet(this, _connector).disconnect();
    }
    /**
     * Fetch the GeneralConfig object that contains configuration data both of
     * the hatch and the hatch oracle.
     * @returns {Promise<GeneralConfig>} A promise that resolves to a GeneralConfig
     * entity object.
     */
    generalConfig() {
        return __classPrivateFieldGet(this, _connector).generalConfig(__classPrivateFieldGet(this, _app).organization.address, __classPrivateFieldGet(this, _contractCache));
    }
    /**
     * Subscribe to the GeneralConfig object updates that contains configuration data both
     * of the hatch and the hatch oracle.
     * @param {SubscriptionCallback<GeneralConfig>} callback A callback function that
     * receives the updated general configuration data.
     * @returns {SubscriptionHandler} A function handler used to cancel the
     * subscription at any time.
     */
    onGeneralConfig(callback) {
        return __classPrivateFieldGet(this, _connector).onGeneralConfig(__classPrivateFieldGet(this, _app).organization.address, callback, __classPrivateFieldGet(this, _contractCache));
    }
    /**
     * Fetch multiple contributors.
     * @param {Object} param0 A filtering options object for the query.
     * @returns {Promise<Contributor[]>} A promise which resolves to an array of Contributor objects.
     */
    contributors({ first = 1000, skip = 0, orderBy = 'value', orderDirection = 'desc', } = {}) {
        return __classPrivateFieldGet(this, _connector).contributors(__classPrivateFieldGet(this, _app).address, first, skip, orderBy, orderDirection);
    }
    /**
     * Subscribe to multiple contributors data updates.
     * @param {Object} param0 A filtering options object for the query.
     * @param {SubscriptionCallback<Contributor[]>} callback A callback function that
     * receives the updated array of Contributor objects.
     * @returns {SubscriptionHandler} A function handler used to cancel the
     * subscription at any time.
     */
    onContributors({ first = 1000, skip = 0, orderBy = 'value', orderDirection = 'desc' } = {}, callback) {
        return __classPrivateFieldGet(this, _connector).onContributors(__classPrivateFieldGet(this, _app).address, first, skip, orderBy, orderDirection, callback);
    }
    /**
     * Fetch a single contributor.
     * @param {string} contributor A string that contains the contributor address.
     * @returns {Contributor} A promise that resolves to the searched contributor.
     */
    contributor(contributor = '') {
        return __classPrivateFieldGet(this, _connector).contributor(utils_1.buildContributorId(__classPrivateFieldGet(this, _app).address, contributor));
    }
    /**
     * Subscribe to a single contributor data updates.
     * @param {string} contributor The contributor address.
     * @param {SubscriptionCallback<Contribution>} callback A callback function that
     * receives the updated Contributor object data.
     * @returns {SubscriptionHandler} A function handler used to cancel the subscription
     * at any time.
     */
    onContributor(contributor = '', callback) {
        return __classPrivateFieldGet(this, _connector).onContributor(utils_1.buildContributorId(__classPrivateFieldGet(this, _app).address, contributor), callback);
    }
    /**
     * Fetch multiple contributions.
     * @param {Object} param0 A filtering options object for the query.
     * @returns {Promise<Contribution[]>} A promise that resolves to an array of Contribution objects.
     */
    contributions({ contributor = '', first = 1000, skip = 0, orderBy = 'value', orderDirection = 'desc', } = {}) {
        return __classPrivateFieldGet(this, _connector).contributions(__classPrivateFieldGet(this, _app).address, contributor.toLowerCase(), first, skip, orderBy, orderDirection);
    }
    /**
     * Subscribe to multiple contributions data updates.
     * @param {Object} param0 A filtering options object for the query.
     * @param {SubscriptionCallback<Contribution[]} callback A callback function that
     * receives the updated array of Contribution objects.
     * @returns {SubscriptionHandler} A function handler used to cancel the subscription
     * at any time.
     */
    onContributions({ contributor = '', first = 1000, skip = 0, orderBy = 'value', orderDirection = 'desc', } = {}, callback) {
        return __classPrivateFieldGet(this, _connector).onContributions(__classPrivateFieldGet(this, _app).address, contributor.toLowerCase(), first, skip, orderBy, orderDirection, callback);
    }
    /**
     * Open the hatch.
     * @param {Address} signerAddress A string that contains the transaction signer address.
     * @returns {Promise<ForwardingPath>} A promise that resolves to a ForwardingPath
     * object which contains all the transactions needed to be signed in order to open
     * the hatch.
     */
    async open(signerAddress) {
        return __classPrivateFieldGet(this, _app).intent('open', [], { actAs: signerAddress });
    }
    /**
     * Close the hatch.
     * @param {Address} signerAddress A string that contains the transaction signer address.
     * @returns {Promise<ForwardingPath>} A promise that resolves to a ForwardingPath
     * object which contains all the transactions needed to be signed in order to close
     * the hatch.
     */
    async close(signerAddress) {
        return __classPrivateFieldGet(this, _app).intent('close', [], { actAs: signerAddress });
    }
    /**
     * Contribute to the hatch.
     * @param {Address} contributor The address of the
     * contributing entity.
     * @param {string} value A string that contains the amount of tokens to contribute.
     * @returns {Promise<ForwardingPath>} A promise that resolves to a ForwardingPath object
     * which contains all the transactions needed to be signed in order to contribute to the hatch.
     */
    async contribute(contributor, value) {
        const intent = await __classPrivateFieldGet(this, _app).intent('contribute', [value], {
            actAs: contributor,
        });
        const { hatchConfig: { contributionToken: { id: tokenAddress }, }, } = await __classPrivateFieldGet(this, _connector).generalConfig(__classPrivateFieldGet(this, _app).organization.address, __classPrivateFieldGet(this, _contractCache));
        const preTransactions = [];
        const collateralPreTransactions = await intent.buildApprovePreTransactions({
            address: tokenAddress,
            value,
        });
        preTransactions.push(...collateralPreTransactions);
        intent.applyPreTransactions(preTransactions);
        return intent;
    }
    /**
     * Refund a contributor hatch contribution.
     * @param {Address} contributor The address of the contributor.
     * @param {number} vestedPurchaseId The id of the vested hatch tokens purchase.
     * @returns {Promise<ForwardingPath>} A promise that resolves to a Forwarding Path
     * object which contains all the transactions needed to be signed in order to get
     * a refund from the hatch.
     */
    async refund(contributor, vestedPurchaseId) {
        return __classPrivateFieldGet(this, _app).intent('refund', [contributor, vestedPurchaseId], {
            actAs: contributor,
        });
    }
    async reserveTokenBalance() {
        const hatch = await __classPrivateFieldGet(this, _contractCache).loadContractFromOrg(utils_1.HATCH_APP);
        const contributionToken = await __classPrivateFieldGet(this, _contractCache).loadContractFromStateVariable(hatch, 'contributionToken', 'erc20');
        const reserveAgent = await __classPrivateFieldGet(this, _contractCache).loadContractFromStateVariable(hatch, 'reserve', 'agent');
        return reserveAgent.balance(contributionToken.address);
    }
    /**
     * Fetch a holder's contribution token balance.
     * @param {Address} account The account address.
     * @returns {Promise<BigNumber>} A promise that resolves to the holder
     * token balance.
     */
    async contributionTokenBalance(account) {
        const hatch = await __classPrivateFieldGet(this, _contractCache).loadContractFromOrg(utils_1.HATCH_APP);
        return hatch.balanceOf(account);
    }
    /**
     * Return the allowed amount of contribution tokens someone can contribute to the
     * hatch based on how much score tokens he has.
     * @param {Address} account The account address.
     * @returns {Promise<BigNumber>} A promise that resolves to the allowed
     * contribution token amount.
     */
    async allowedContributionAmount(account) {
        const hatchOracle = await __classPrivateFieldGet(this, _contractCache).loadContractFromOrg(utils_1.HATCH_ORACLE_APP);
        return hatchOracle.allowance(account);
    }
    /**
     * Fetch awarded hatch token amount based on the
     * impact hours formula.
     * @param {Address} account The account address.
     * @returns {Promise<BigNumber>} A promise that resolves to the
     * contributor's awarded tokens amount
     */
    async awardedTokenAmount(account) {
        const hatch = await __classPrivateFieldGet(this, _contractCache).loadContractFromOrg(utils_1.HATCH_APP);
        const impactHours = await __classPrivateFieldGet(this, _contractCache).loadContractFromOrg(utils_1.IMPACT_HOURS_APP);
        const totalRaised = await hatch.totalRaised();
        return impactHours.reward(totalRaised, account);
    }
}
_app = new WeakMap(), _connector = new WeakMap(), _contractCache = new WeakMap();
exports.default = Hatch;
//# sourceMappingURL=Hatch.js.map